'use client';

import { signIn } from "next-auth/react";
import { MouseEvent, useState } from "react";
import { useNavigation } from '@/app/navigation-context';

export default function LoginButton() {
  const [isDisabled, setIsDisabled,] = useState(false);
  const { startLoading, } = useNavigation();
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    setIsDisabled(true);
    startLoading(`/api/auth/signin`);
    setTimeout(() => signIn(), 0);
  };

  return <a href='#' style={isDisabled ? {
    pointerEvents: `none`,
    cursor: `default`,
  } : {}} onClick={handleClick}>LOGIN</a>;
}
